/* eslint-disable react/jsx-closing-bracket-location */
// eslint-disable-next-line no-use-before-define
import React, { Component } from "react";
import { connect } from "react-redux";
import { MD5 } from "crypto-js";
import { Dispatch } from "redux";
import Button from "../../../shared/components/button/button";
import InputFieldComponent from "../../../shared/components/forms/input-field/input-field";
import {
  Props,
  State,
} from "../../../shared/interfaces/components/activationPage.interface";
import * as actions from "../../../store/activationPage/actions";
import { activationPageStateReducer } from "../../../shared/interfaces/reducers/reducer.interface";
import { withNavigate } from "../../authentication/pages/navigateWrapper";
import { KeyRound } from "lucide-react";

class ActivationPage extends Component<Props & { navigate: Function }, State> {
  constructor(props: Props & { navigate: Function }) {
    super(props);

    this.state = {
      password: "",
      confirmedPassword: "",
      passwordError: "",
    };
  }

  onChangeHandler = (field: string, value: string) => {
    switch (field) {
      case "pass1": {
        const md5Value = MD5(value).toString();
        this.setState(() => ({ password: value }));
        break;
      }
      case "pass2": {
        const md5Value = MD5(value).toString();
        this.setState(() => ({ confirmedPassword: value }));
        break;
      }

      default: {
        break;
      }
    }
  };

  render() {
    // destructuring state
    const { password, confirmedPassword } = this.state;
    // destructuring Props
    const { token } = this.props;

    const sendPassword = () => {
      const checkPassword = () => {
        if (password.length < 8) {
          // return "La tua password deve avere 8 o più caratteri";
          return "Password must be at least 8 characters long";
        }

        if (password !== confirmedPassword) {
          return "Passwords must match";
        }

        if (!/[A-Z]/.test(password)) {
          return "Password must contain at least one uppercase letter";
        }

        if (!/[a-z]/.test(password)) {
          return "Password must contain at least one lowercase letter";
        }

        if (!/[!@£$%&/()=?^]/.test(password)) {
          return "Password must contain at least one special character [!@£$%&/()=?^]";
        }

        if (/\s/.test(password)) {
          return "Password must not contain spaces";
        }

        if (password.length > 30) {
          return "Password must be at most 30 characters long";
        }

        return false;
      };

      const checkPasswordResult = checkPassword();

      if (!checkPasswordResult) {
        this.setState((prevState) => ({
          ...prevState,
          passwordError: "",
        }));
        // eslint-disable-next-line react/destructuring-assignment
        const payload = {
          password,
          docId: token?.docId,
        };
        // eslint-disable-next-line react/destructuring-assignment
        this.props.postSetPasswordRequest(payload);
      } else {
        this.setState((prevState) => ({
          ...prevState,
          passwordError: checkPasswordResult,
        }));
      }
    };
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <div className="w-full max-w-md bg-white rounded-xl shadow-lg p-8 space-y-6">
          <div className="text-center space-y-2">
            <KeyRound className="mx-auto h-12 w-12 text-blue-600" />
            <h1 className="text-2xl font-bold text-gray-900">
              Activation Account
            </h1>
            <p className="text-gray-600">
              Please set up your password to activate your account
            </p>
          </div>

          <div className="space-y-4">
            <div>
              <label
                htmlFor="pass1"
                className="block text-sm font-medium text-gray-700 mb-2"
              >
                Insert password
              </label>
              <InputFieldComponent
                name="password"
                type="password"
                id="pass1"
                value={password}
                placeholder="Insert password"
                title="Insert password"
                onChangeHandler={(e) =>
                  this.onChangeHandler("pass1", e.target.value)
                }
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
            </div>

            <div>
              <label
                htmlFor="pass2"
                className="block text-sm font-medium text-gray-700 mb-2"
              >
                Confirm Password
              </label>
              <InputFieldComponent
                name="confirmedPassword"
                type="password"
                id="pass2"
                value={confirmedPassword}
                placeholder="Confirm Password"
                title="Confirm Password"
                onChangeHandler={(e) =>
                  this.onChangeHandler("pass2", e.target.value)
                }
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
            </div>

            {this.state.passwordError && (
              <div className="p-4 text-sm text-red-700 bg-red-50 rounded-lg">
                {this.state.passwordError}
              </div>
            )}

            <div className="space-y-4">
              {this.props.isSetPasswordOk ? (
                <div className="text-center space-y-4">
                  <div className="p-4 text-sm text-green-700 bg-green-50 rounded-lg">
                    Account activated successfully!
                  </div>
                  <Button
                    onClickHandler={() => this.props.navigate("/")}
                    title="Go To Login Page"
                    // className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors"
                  />
                </div>
              ) : (
                <div className="flex items-center justify-center gap-2">
                  <Button
                    disabled={this.props.asyncReturned}
                    title="Confirm"
                    onClickHandler={sendPassword}
                    // className="bg-blue-600 text-white py-2 px-6 rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50"
                  />
                  {this.props.asyncReturned !== undefined &&
                    !this.props.asyncReturned && (
                      <svg
                        className="animate-spin h-5 w-5 text-blue-600"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                          fill="none"
                        />
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        />
                      </svg>
                    )}
                </div>
              )}
            </div>

            {this.props.asyncReturned && !this.props.isSetPasswordOk && (
              <div className="p-4 text-sm text-red-700 bg-red-50 rounded-lg">
                The token used is invalid or expired
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  postSetPasswordRequest: (payload: object) => {
    dispatch(actions.postSetPasswordRequest(payload));
  },
});
const mapStateToProps = (state: activationPageStateReducer) => ({
  isSetPasswordOk: state.setPasswordReducer.isSetPasswordOk,
  asyncReturned: state.setPasswordReducer.asyncReturned,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNavigate(ActivationPage));
